module.exports = __webpack_public_path__ + "static/media/video-player-orange.38a2ec64.svg";